import { ApiEmailService } from '../../config/apiService';
import { SET_BAGE_COUNT } from '../actionTypes/mail';

export const setBageCount = () => (dispatch) => {
  try {
    ApiEmailService.getEmailUnreadCount().then((count) => {
      dispatch({
        type: SET_BAGE_COUNT,
        payload: count,
      });
    });
  } catch (error) {
    dispatch({
      type: SET_BAGE_COUNT,
      payload: 0,
    });
  }
};
